import {
  ChainType,
  calculateTotalBalance,
  filterBalancesByChains,
  filterBalancesSummary,
  filterWalletGroupedAccounts,
} from '@polaris/core/models'
import { featureFlagsAtom } from '@polaris/core/stores'
import { atom } from 'jotai'
import { mpcWalletAddressesWithNamadaOverrideAtom } from '@/src/stores/mpc/atoms'
import { accountsAddressesAtom } from '../accounts/atoms'
import { walletAccountsAtom } from '../accounts/wallets'
import { balancesByChainsAtom, balancesSummaryAtom } from './atom'

/**
 * Atom version of useAccountsFilteredBalances without parameters.
 * Includes default filter to only include balances in Polaris accounts/portfolio.
 */
export const accountsFilteredBalancesAtom = atom((get) => {
  const { privacy } = get(featureFlagsAtom)
  const { data: mpcWalletAddresses } = get(
    mpcWalletAddressesWithNamadaOverrideAtom,
  )
  const accountsAddresses = get(accountsAddressesAtom)
  const unfilteredBalancesSummary = get(balancesSummaryAtom)
  const unfilteredBalancesByChains = get(balancesByChainsAtom)
  const { groupedAccounts } = get(walletAccountsAtom)

  // Build addresses list (whitelist for filtering)
  const addresses = [...accountsAddresses]
  if (privacy && mpcWalletAddresses?.namada) {
    addresses.push(mpcWalletAddresses.namada)
  }

  const filter = { addresses }

  const balancesByChains = filterBalancesByChains(
    unfilteredBalancesByChains,
    filter,
  )

  const balancesSummary = filterBalancesSummary(
    unfilteredBalancesSummary,
    filter,
  )

  const privacyBalancesSummary = filterBalancesSummary(
    unfilteredBalancesSummary,
    {
      ...filter,
      chainType: ChainType.Namada,
    },
  )

  const filteredGroupedAccounts = filterWalletGroupedAccounts(
    groupedAccounts,
    filter,
  )

  const totalBalance = calculateTotalBalance(balancesSummary)

  return {
    balancesSummary,
    privacyBalancesSummary,
    balancesByChains,
    groupedAccounts: filteredGroupedAccounts,
    totalBalance,
  }
})
